import { Component, computed, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ClassValue } from 'clsx';
import { bui } from '../utils/bui';

@Component({
  selector: 'sidebar-icon',
  exportAs: 'sidebarIcon',
  imports: [MatIcon],
  host: {
    '[class]': 'computedClass()',
  },
  template: `<mat-icon class="size-full text-current" [svgIcon]="icon()" />`,
})
export class SidebarIcon {
  // Inputs / Outputs
  readonly icon = input.required<string>();
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  // State
  protected readonly computedClass = computed(() =>
    bui(
      // Base
      'group/sidebar-icon',
      'pointer-events-none flex items-center justify-center',
      'size-5 shrink-0 p-0.5',
      'text-neutral-a11',

      // User classes
      this.userClass(),
    ),
  );
}
